export default __webpack_public_path__ + "static/media/question001_qa_content.7b843f8d.jpg";